import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Dropdown from "react-bootstrap/Dropdown";
import Alert from "react-bootstrap/Alert"; // ✅ NEW
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import Details from "./details.js";
import Preference from "./preference";
import Contacts from "./contacts";
import Notes from "./notes.js";
import Instruction from "./instruction.js";
import PriceList from "./pricelist.js";
import Procedures from "./procedure.js";
import Activity from "./activity.js";


function TabsWorking() {
  const location = useLocation();
  const { accountId } = useParams();
  const navigate = useNavigate();

  const [accountData, setAccountData] = useState(
    location.state?.accountData || {}
  );
  const [accountName, setAccountName] = useState(
    location.state?.accountName || "Account Details"
  );
  const [activeTab, setActiveTab] = useState("Details");
  const [inviteMessage, setInviteMessage] = useState(false); // ✅ NEW

  useEffect(() => {
    if (!location.state?.accountData && accountId) {
      const fetchAccountData = async () => {
        try {
          const response = await fetch(
            `https://hms.backend.hiragroupcloud.com//api/account/account/${accountId}`
          );
          const data = await response.json();

          if (response.ok) {
            setAccountData(data);
            setAccountName(data.account_name || data.name || "Account Details");
            
          } else {
            throw new Error(data.message || "Failed to fetch account data");
          }
        } catch (error) {
          console.error("Error fetching account data:", error);
          navigate("/accounts");
        }
      };

      fetchAccountData();
    } else {
      
    }
  });

  const handleNavigation = (path, state) => {
    navigate(path, { state });
    
  };

  const handleInviteClick = () => {
    setInviteMessage(true);
  };

  return (
    <>
      <div style={{ marginBottom: "10px" }}>
        
      </div>
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
        

          <div className="col-md-10">
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ width: "100%" }}
            >
              <h2 style={{ marginTop: "1%" }}>Account {accountName}</h2>

              <Dropdown>
                <Dropdown.Toggle
                  variant="primary"
                  id="dropdown-custom-components"
                  style={{
                    backgroundColor: "#004aad",
                    borderColor: "#004aad",
                    color: "white",
                    borderRadius: "5px",
                    boxShadow: "none",
                  }}
                >
                  Action
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ minWidth: "200px", fontSize: "15px" }}>
                  <Dropdown.Header
                    style={{ fontSize: "18px", fontWeight: "bold" }}
                  >
                    Cases
                  </Dropdown.Header>
                  <Dropdown.Item
                    as={Link}
                    to="/openCases"
                    state={{ accountName, accountId }}
                    onClick={() =>
                      handleNavigation("/openCases", { accountName, accountId })
                    }
                  >
                    View Open Cases
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/casesOpened"
                    state={{ accountName, accountId }}
                    onClick={() =>
                      handleNavigation("/casesOpened", {
                        accountName,
                        accountId,
                      })
                    }
                  >
                    View All Cases
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/View cases To Ship">
                    View Cases To Ship
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/Create Cases">
                    Create Cases
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/New Cases Pickup">
                    New Cases Pickup
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Header
                    style={{ fontSize: "18px", fontWeight: "bold" }}
                  >
                    Patients
                  </Dropdown.Header>
                  <Dropdown.Item as={Link} to="/View All Patients">
                    View All Patients
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Header
                    style={{ fontSize: "18px", fontWeight: "bold" }}
                  >
                    Invite
                  </Dropdown.Header>
                  <Dropdown.Item onClick={handleInviteClick}>
                    Invite to DDX
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            {/* ✅ Message Shown After Invite Click */}
            {inviteMessage && (
              <Alert
                variant="success"
                style={{ marginTop: "10px", width: "fit-content" }}
              >
                ✅ Invite has been sent. Your account is now connected with DDX.
              </Alert>
            )}

            <div>
              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                {[
                  {
                    key: "Details",
                    title: "Details",
                    component: <Details accountData={accountData} />,
                  },
                  {
                    key: "Preferences",
                    title: "Preferences",
                    component: <Preference accountData={accountData} />,
                  },
                  {
                    key: "Contacts",
                    title: "Contacts",
                    component: <Contacts accountData={accountData} />,
                  },
                  {
                    key: "Notes",
                    title: "Notes",
                    component: <Notes accountData={accountData} />,
                  },
                  {
                    key: "Instruction",
                    title: "Instruction",
                    component: <Instruction accountData={accountData} />,
                  },
                  {
                    key: "pricelist",
                    title: "Pricelist",
                    component: <PriceList accountData={accountData} />,
                  },
                  {
                    key: "Procedures",
                    title: "Procedures",
                    component: <Procedures accountData={accountData} />,
                  },
                  {
                    key: "Activity",
                    title: "Activity",
                    component: <Activity accountData={accountData} />,
                  },
                ].map((tab) => (
                  <Tab
                    key={tab.key}
                    eventKey={tab.key}
                    title={
                      <div
                        style={{
                          padding: "8px 16px",
                          backgroundColor:
                            activeTab === tab.key ? "#004aad" : "transparent",
                          color: activeTab === tab.key ? "#fff" : "#004aad",
                          fontWeight: activeTab === tab.key ? "bold" : "normal",
                          borderRadius: "8px 8px 0 0",
                          cursor: "pointer",
                          transition: "0.3s",
                        }}
                      >
                        {tab.title}
                      </div>
                    }
                  >
                    {tab.component}
                  </Tab>
                ))}
              </Tabs>
            </div>
          </div>
        </div>

 
      </div>
    </>
  );
}

export default TabsWorking;
